const API_BASE_URL = 'https://fundit-backend.onrender.com/api';

export default API_BASE_URL;